import { Map } from 'immutable'
import { combineReducers } from 'redux-immutable'
import { combineActions, handleActions } from 'redux-actions'
import ConversationTypes from 'utils/ConversationTypes'

import * as ConversationActions from 'app/modules/conversation/actions'
import * as MessageActions from 'app/modules/message/actions'

const READABLE_MESSAGE_TYPES = [
  ConversationTypes.CHAT,
  ConversationTypes.EMAIL,
  ConversationTypes.PRIVATE_NOTE,
  ConversationTypes.PRIVATE_PROMPT,
]

const lastMessageByConversationId = handleActions({
  [ConversationActions.receiveConversation]: (state, action) => {
    const {
      conversation: {
        id,
        lastSentMessageTimestamp: sentAt,
        lastReadMessageTimestamp: readAt,
      }
    } = action.payload

    return state.withMutations(state => {
      if (sentAt) {
        const prevSentAt = state.getIn([id, 'sentAt'])
        if (!prevSentAt || (prevSentAt < sentAt)) {
          state.setIn([id, 'sentAt'], sentAt)
        }
      }

      if (readAt) {
        const prevReadAt = state.getIn([id, 'readAt'])
        if (!prevReadAt || prevReadAt < readAt) {
          state.setIn([id, 'readAt'], readAt)
        }
      }
    })
  },
  [combineActions(
    ConversationActions.fetchConversationListSuccess,
    ConversationActions.fetchNextConversationListSuccess,
  )]: (state, action) => {
    const { paginatedConversations: { data: conversations }} = action.payload

    return state.withMutations(state => {
      conversations.forEach(conversation => {
        const {
          id,
          lastSentMessageTimestamp: sentAt,
          lastReadMessageTimestamp: readAt,
        } = conversation

        if (sentAt) {
          const prevSentAt = state.getIn([id, 'sentAt'])
          if (!prevSentAt || (prevSentAt < sentAt)) {
            state.setIn([id, 'sentAt'], sentAt)
          }
        }

        if (readAt) {
          const prevReadAt = state.getIn([id, 'readAt'])
          if (!prevReadAt || prevReadAt < readAt) {
            state.setIn([id, 'readAt'], readAt)
          }
        }
      })
    })
  },
  [combineActions(
    MessageActions.receiveFirstMessages,
    MessageActions.receivePaginatedMessageList,
    MessageActions.receiveNextMessageList,
  )]: (state, action) => {
    const { messages, conversationId } = action.payload

    const latestReadableMessage = messages.reduce((latestReadableMessage, currentMessage) => {
      return READABLE_MESSAGE_TYPES.includes(currentMessage.type) &&
        (!latestReadableMessage || (latestReadableMessage.createdAt < currentMessage.createdAt)) &&
        currentMessage
    })

    return state.withMutations(state => {
      if (latestReadableMessage) {
        const sentAt = latestReadableMessage.createdAt
        const readAt = (latestReadableMessage.viewerRecipientStatus === 'Read') && latestReadableMessage.createdAt

        const prevSentAt = state.getIn([conversationId, 'sentAt'])
        if (!prevSentAt || (prevSentAt < sentAt)) {
          state.setIn([conversationId, 'sentAt'], sentAt)
        }

        if (readAt) {
          const prevReadAt = state.getIn([conversationId, 'readAt'])
          if (!prevReadAt || prevReadAt < readAt) {
            state.setIn([conversationId, 'readAt'], readAt)
          }
        }
      }
    })
  },
  [MessageActions.receiveMessage]: (state, action) => {
    const { message, conversationId } = action.payload

    return state.withMutations(state => {
      const isReadableMessage = READABLE_MESSAGE_TYPES.includes(message.type)

      if (isReadableMessage) {
        const sentAt = message.createdAt

        const prevSentAt = state.getIn([conversationId, 'sentAt'])
        if (!prevSentAt || (prevSentAt < sentAt)) {
          state.setIn([conversationId, 'sentAt'], sentAt)
        }
      }
    })
  },
  [MessageActions.optimisticMessageReadSuccess]: (state, action) => {
    const { messageCreatedAt: readAt, conversationId } = action.payload

    return state.withMutations(state => {
      const prevReadAt = state.getIn([conversationId, 'readAt'])
      if (!prevReadAt || prevReadAt < readAt) {
        state.setIn([conversationId, 'readAt'], readAt)
      }
    })
  },
}, Map())

export default combineReducers({
  lastMessageByConversationId,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/unread/reducer.js